const ROOT = "settings-fullscreen-mobile";
export {
  ROOT
};
//# sourceMappingURL=data-hooks.js.map
